/* eslint-disable max-len */
import * as questionIds from "../../consultationQuestions/questionIds";

export const rightGripStrengthAverageQuestion = {
    id: questionIds.RightGripStrengthAverage,
    questionText: "Grip strength, right hand (in kg) Average",
};

export const leftGripStrengthAverageQuestion = {
    id: questionIds.LeftGripStrengthAverage,
    questionText: "Grip strength, left hand (in kg) Average",
};

export const examinationQuestions = [
    {
        id: questionIds.HavsAssessmentRequired,
        questionText: "Following review of the HAVS questionnaire",
    },
    {
        id: questionIds.LastExposureToVibration,
        questionText: "Note last exposure to vibration",
    },
    {
        id: questionIds.RoomTemperature,
        questionText: "Room temperature (ºC)",
    },
    {
        id: questionIds.ExaminationUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.ExaminationUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.AppearanceOfHands,
        questionText: "Appearance of hands – note any signs of vascular disease, deformity, scars, callosities or muscle wasting.",
    },
    {
        id: questionIds.RightPulseRate,
        questionText: "Pulse rate (bpm) (Right)",
    },
    {
        id: questionIds.LeftPulseRate,
        questionText: "Pulse rate (bpm) (Left)",
    },
    {
        id: questionIds.RightBloodPressure,
        questionText: "Blood pressure (mm Hg) Lying/Sitting (Right)",
    },
    {
        id: questionIds.LeftBloodPressure,
        questionText: "Blood pressure (mm Hg) Lying/Sitting (Left)",
    },
    {
        id: questionIds.RightPositiveRadialPulse,
        questionText: "Positive Radial pulse (Right)",
    },
    {
        id: questionIds.RightAbsentRadialPulse,
        questionText: "Absent Radial pulse (Right)",
    },
    {
        id: questionIds.LeftPositiveRadialPulse,
        questionText: "Positive Radial pulse (Left)",
    },
    {
        id: questionIds.LeftAbsentRadialPulse,
        questionText: "Absent Radial pulse (Left)",
    },
    {
        id: questionIds.RightPositiveUlnarPulse,
        questionText: "Positive Ulnar pulse (Right)",
    },
    {
        id: questionIds.RightAbsentUlnarPulse,
        questionText: "Absent Ulnar pulse (Right)",
    },
    {
        id: questionIds.LeftPositiveUlnarPulse,
        questionText: "Positive Ulnar pulse (Left)",
    },
    {
        id: questionIds.LeftAbsentUlnarPulse,
        questionText: "Absent Ulnar pulse (Left)",
    },
    {
        id: questionIds.RightPositiveAllensTest,
        questionText: "Positive Allen's test (Right)",
    },
    {
        id: questionIds.RightNegativeAllensTest,
        questionText: "Negative Allen's test (Right)",
    },
    {
        id: questionIds.LeftPositiveAllensTest,
        questionText: "Positive Allen's test (Left)",
    },
    {
        id: questionIds.LeftNegativeAllensTest,
        questionText: "Negative Allen's test (Left)",
    },
    {
        id: questionIds.RightNormalSemmesWeinstein,
        questionText: "Normal Semmes-Weinstein (Right)",
    },
    {
        id: questionIds.RightAbnormalSemmesWeinstein,
        questionText: "Abnormal Semmes-Weinstein (Right)",
    },
    {
        id: questionIds.LeftNormalSemmesWeinstein,
        questionText: "Normal Semmes-Weinstein (Left)",
    },
    {
        id: questionIds.LeftAbnormalSemmesWeinstein,
        questionText: "Abnormal Semmes-Weinstein (Left)",
    },
    {
        id: questionIds.RightNormalPurduePegboardTest,
        questionText: "Normal Manual dexterity (Purdue Pegboard test) (Right)",
    },
    {
        id: questionIds.RightAbnormalPurduePegboardTest,
        questionText: "Abnormal Manual dexterity (Purdue Pegboard test) (Right)",
    },
    {
        id: questionIds.LeftNormalPurduePegboardTest,
        questionText: "Normal Manual dexterity (Purdue Pegboard test) (Left)",
    },
    {
        id: questionIds.LeftAbnormalPurduePegboardTest,
        questionText: "Abnormal Manual dexterity (Purdue Pegboard test) (Left)",
    },
    {
        id: questionIds.RightNormalAdsonsTest,
        questionText: "Normal Adson's test (Right)",
    },
    {
        id: questionIds.RightAbnormalAdsonsTest,
        questionText: "Abnormal Adson's test (Right)",
    },
    {
        id: questionIds.LeftNormalAdsonsTest,
        questionText: "Normal Adson's test (Left)",
    },
    {
        id: questionIds.LeftAbnormalAdsonsTest,
        questionText: "Abnormal Adson's test (Left)",
    },
    {
        id: questionIds.RightNormalTinelsTest,
        questionText: "Normal Tinel's test (Right)",
    },
    {
        id: questionIds.RightAbnormalTinelsTest,
        questionText: "Abnormal Tinel's test (Right)",
    },
    {
        id: questionIds.LeftNormalTinelsTest,
        questionText: "Normal Tinel's test (Left)",
    },
    {
        id: questionIds.LeftAbnormalTinelsTest,
        questionText: "Abnormal Tinel's test (Left)",
    },
    {
        id: questionIds.RightNormalPhalensTest,
        questionText: "Normal Phalen's test (Right)",
    },
    {
        id: questionIds.RightAbnormalPhalensTest,
        questionText: "Abnormal Phalen's test (Right)",
    },
    {
        id: questionIds.LeftNormalPhalensTest,
        questionText: "Normal Phalen's test (Left)",
    },
    {
        id: questionIds.LeftAbnormalPhalensTest,
        questionText: "Abnormal Phalen's test (Left)",
    },
    {
        id: questionIds.AbnormalityOfNecksOrUpperLimbs,
        questionText: "Describe any abnormality of neck or upper limbs",
    },
    {
        id: questionIds.RightGripStrength1,
        questionText: "Grip strength, right hand (in kg) Measurement 1",
    },
    {
        id: questionIds.RightGripStrength2,
        questionText: "Grip strength, right hand (in kg) Measurement 2",
    },
    {
        id: questionIds.RightGripStrength3,
        questionText: "Grip strength, right hand (in kg) Measurement 3",
    },
    rightGripStrengthAverageQuestion,
    {
        id: questionIds.LeftGripStrength1,
        questionText: "Grip strength, left hand (in kg) Measurement 1",
    },
    {
        id: questionIds.LeftGripStrength2,
        questionText: "Grip strength, left hand (in kg) Measurement 2",
    },
    {
        id: questionIds.LeftGripStrength3,
        questionText: "Grip strength, left hand (in kg) Measurement 3",
    },
    leftGripStrengthAverageQuestion,
    {
        id: questionIds.PrimaryRaynaudsPhenomenonPresent,
        questionText: "Primary Raynaud’s phenomenon present? ",
    },
    {
        id: questionIds.SecondaryRaynaudsPhenomenonPresent,
        questionText: "Secondary Raynaud’s phenomenon present?",
    },
    {
        id: questionIds.RaynaudsPhenomenonPresentVibrationInduced,
        questionText: "Is the vibration induced?",
    },
    {
        id: questionIds.RightStockholmVascularGrading,
        questionText: "Stockholm Vascular grading (Right)",
    },
    {
        id: questionIds.LeftStockholmVascularGrading,
        questionText: "Stockholm Vascular grading (Left)",
    },
    {
        id: questionIds.NeurologicalImpairmentSuggested,
        questionText: "Neurological impairment suggested by clinical assessment?",
    },
    {
        id: questionIds.CarpalTunnelSyndromeSuggested,
        questionText: "Is carpal tunnel syndrome suggested by history and findings?",
    },
    {
        id: questionIds.RightStockholmSensorineuralGrading,
        questionText: "Stockholm Sensorineural grading (Right)",
    },
    {
        id: questionIds.LeftStockholmSensorineuralGrading,
        questionText: "Stockholm Sensorineural grading (Left)",
    },
    {
        id: questionIds.MuscularSoftTissueDisorderPresent,
        questionText: "Muscular or soft tissue disorder present?",
    },
    {
        id: questionIds.EvidenceSkeletalDisorder,
        questionText: "Evidence of skeletal disorder?",
    },
    {
        id: questionIds.VascularLatentPeriods,
        questionText: "Vascular Latent periods (in years)",
    },
    {
        id: questionIds.NeurologicalLatentPeriods,
        questionText: "Neurological Latent periods (in years)",
    },
    {
        id: questionIds.MusculoskeletalLatentPeriods,
        questionText: "Musculoskeletal Latent periods (in years)",
    },
    {
        id: questionIds.VibrotactileThresholdFurtherInvestigationsRequired,
        questionText: "Vibrotactile Threshold - Further special investigations required?",
    },
    {
        id: questionIds.TemperatureThresholdFurtherInvestigationsRequired,
        questionText: "Temperature Threshold - Further special investigations required?",
    },
    {
        id: questionIds.RadialPulseRight,
        questionText: "Right",
    },
    {
        id: questionIds.RadialPulseLeft,
        questionText: "Left",
    },
    {
        id: questionIds.UlnarPulseRight,
        questionText: "Right",
    },
    {
        id: questionIds.UlnarPulseLeft,
        questionText: "Left",
    },
    {
        id: questionIds.AllensTestRight,
        questionText: "Right",
    },
    {
        id: questionIds.AllensTestLeft,
        questionText: "Left",
    },
    {
        id: questionIds.SemmesWeinsteinRight,
        questionText: "Right",
    },
    {
        id: questionIds.SemmesWeinsteinRightScore,
        questionText: "Score",
    },
    {
        id: questionIds.SemmesWeinsteinLeft,
        questionText: "Left",
    },
    {
        id: questionIds.SemmesWeinsteinLeftScore,
        questionText: "Score",
    },
    {
        id: questionIds.ManualDexterityRight,
        questionText: "Right",
    },
    {
        id: questionIds.ManualDexterityRightScore,
        questionText: "Score",
    },
    {
        id: questionIds.ManualDexterityLeft,
        questionText: "Left",
    },
    {
        id: questionIds.ManualDexterityLeftScore,
        questionText: "Score",
    },
    {
        id: questionIds.ManualDexterityBothScore,
        questionText: "Score",
    },
    {
        id: questionIds.AdsonsTestRight,
        questionText: "Right",
    },
    {
        id: questionIds.AdsonsTestLeft,
        questionText: "Left",
    },
    {
        id: questionIds.TinelsTestRight,
        questionText: "Right",
    },
    {
        id: questionIds.TinelsTestLeft,
        questionText: "Left",
    },
    {
        id: questionIds.PhelansTestRight,
        questionText: "Right",
    },
    {
        id: questionIds.PhelansTestLeft,
        questionText: "Left",
    },
    {
        id: questionIds.AdvisoryLeafletReceivedByEmployee,
        questionText: "Has advisory leaflet been received by employee?",
    },
];
/* eslint-enable max-len */
